import {Injectable, NgModule} from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterModule, RouterStateSnapshot, Routes } from '@angular/router';
import {UserCreateComponent} from './user-create/user-create.component';
import {UserListComponent} from './user-list/user-list.component';
import {UsersComponent} from './users.component';
import {UserDetailComponent} from './user-detail/user-detail.component';
import {UserManagementGuard} from '../shared/user-management.guard';
import {UserListLegacyComponent} from './user-list-legacy/user-list-legacy.component';
import {environment} from '../../environments/environment';
import {LoadParametersGuard} from './guards/LoadParametersGuard';
import {TransactionLogComponent} from './transaction-log/transaction-log.component';
import {TwoFctorBulkUpdateDialogComponent} from "./2fa-bulk-update/2fa-bulk-update-dialog.component";
import {UserListAdminGuard} from "../shared/user-list-admin.guard";
import { oktaIdmCanActivate } from '../shared/oktaIdmCanActivate';
import { SecurityService } from '../shared/security.service';

export function onAuthRequired({ oktaAuth, router }) {
  // Redirect the user to your custom login page
  router.navigate(['/login']);
}


@Injectable()
// remove this in a subsequent relase
export class LegacyGuard  {
  constructor(private router:Router) {

  }
  canActivate(route: ActivatedRouteSnapshot, _state: RouterStateSnapshot) {
     if (environment.useLegacyAPI) {
      this.router.navigate([ '/users-legacy' ])
    }
    return true;

  }

}
const routes: Routes = [
  {
    path: 'users',
    component: UsersComponent,
    canActivate: [ oktaIdmCanActivate, UserListAdminGuard, LoadParametersGuard ],

    data: {
          onAuthRequired
    },
    children: [
      {
        path: '',
        component: UserListComponent,
        canActivate: [ LegacyGuard ] // remove this in a subsequent relase
      }
    ]
  },
  {
    path: 'users-legacy',
    component: UserListLegacyComponent,
    canActivate: [ oktaIdmCanActivate, UserListAdminGuard, LoadParametersGuard ],
    data: {
      onAuthRequired
    }
  },
  {
    path: 'transaction-log',
    component: TransactionLogComponent,
    canActivate: [ oktaIdmCanActivate, UserManagementGuard, LoadParametersGuard ],
    data: {
      onAuthRequired
    }
  },
  {
    path: '2fa-bulk-update',
    component: TwoFctorBulkUpdateDialogComponent,
    canActivate: [ oktaIdmCanActivate, UserManagementGuard, LoadParametersGuard ],
    data: {
      onAuthRequired,
      groupGuardValidate: (svc: SecurityService) => {
        return svc.isManageRulesUser();
      }
    }
  },
  {
    path: 'user',
    component: UsersComponent,
    children: [
      {
        path: 'new',
        component: UserCreateComponent,
        canActivate: [ oktaIdmCanActivate, UserManagementGuard, LoadParametersGuard],
        data: {
          onAuthRequired
        }
     },
      {
        path: ':id',
        component: UserDetailComponent,
        canActivate: [ oktaIdmCanActivate,UserListAdminGuard, LoadParametersGuard],
        data: {
          onAuthRequired
        }
      },
      { path: '', redirectTo: 'new', pathMatch: 'full' },
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class UsersRoutingModule { }
